import React, { useEffect, useRef } from 'react';
import lib from './turnstileGuard';

// The React side of ./turnstileGuard.js (read it first): a hook for the
// Turnstile check and the hidden honeypot field.

const { TURNSTILE_SITEKEY, HONEYPOT_FIELD, turnstileGuard } = lib;

/**
 * const human = useTurnstile('contact');
 * <form onFocus={human.start}> … <div ref={human.boxRef} /> … </form>
 * On submit: const turnstileToken = await human.token(); then, once the
 * request is done (sent or not), human.reset().
 */
export const useTurnstile = (action) => {
  const boxRef = useRef(null);
  const guardRef = useRef(null);

  const guard = () => {
    if (!guardRef.current) {
      guardRef.current = turnstileGuard(boxRef.current, action, TURNSTILE_SITEKEY);
    }
    return guardRef.current;
  };

  useEffect(() => () => {
    if (guardRef.current) {
      guardRef.current.remove();
      guardRef.current = null;
    }
  }, []);

  return {
    boxRef,
    start: () => guard().start(),
    token: () => guard().token(),
    reset: () => guard().reset(),
  };
};

// Off screen, out of the tab order and hidden from screen readers: only a
// bot fills it in. Read its value with the ref on submit.
export const Honeypot = ({ inputRef }) => (
  <div aria-hidden="true" style={{ position: 'absolute', left: '-10000px', top: 'auto', width: 1, height: 1, overflow: 'hidden' }}>
    <label>
      Leave this field empty
      <input type="text" name={HONEYPOT_FIELD} tabIndex={-1} autoComplete="off" ref={inputRef} defaultValue="" />
    </label>
  </div>
);

export const honeypotValue = (inputRef) => (inputRef.current ? inputRef.current.value : '');
